import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=6071cb9d&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=6071cb9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071cb9d",
  null
  
)

export default component.exports